import React, { useState, useEffect } from 'react';
import { withFormsy } from 'formsy-react';
import { pick } from 'lodash';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

const CustomTableContainer = styled(TableContainer)(() => ({
  border: '1px solid lightgrey',
  borderRadius: '10px',
  overflow: 'hidden',
}));

function TabularSingleFormsy(props) {
  const importedProps = pick(props, ['onChange']);

  const { errorMessage, description, rowOptions, columnOptions, value } = props;

  function changeValue(event, val) {
    props.setValue(val);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  const generateSelectedOptions = (data) => {
    const options = {};
    rowOptions.map((a) => {
      if (data && data.length > 0) {
        var count = 0;
        data.map((b) => {
          if (b.rowOptionAlias === a.alias) {
            count += 1;
            options[a.alias] = b.columnOptionAliases[0];
          }
        });
        if (count === 0) {
          options[a.alias] = '';
        }
      } else {
        options[a.alias] = '';
      }
    });
    return options;
  };

  let tempOptions = generateSelectedOptions(value);

  const [selectedOptions, setSelectedOptions] = useState(tempOptions);

  const width = 100 / (1 + columnOptions.length) + '%';

  const handleRadioChange = (event, row) => {
    const newOptions = { ...selectedOptions, [row]: event.target.value };
    setSelectedOptions(newOptions);
    processSelectedOptions(event, newOptions);
  };

  const processSelectedOptions = (event, options) => {
    const finalResponse = [];
    rowOptions.map((a) => {
      const responseObj = {
        RowOptionAlias: a.alias,
        RowOption: {
          Alias: a.alias,
          Label: a.label,
        },
        ColumnOptionAliases: [],
        ColumnOptions: [],
      };
      if (options[a.alias]) {
        columnOptions.map((b) => {
          if (options[a.alias] === b.alias) {
            responseObj.ColumnOptionAliases.push(b.alias);
            responseObj.ColumnOptions.push({
              Alias: b.alias,
              Label: b.label,
            });
          }
        });
        finalResponse.push(responseObj);
      }
    });
    changeValue(event, finalResponse);
  };

  return (
    <div>
      <p>{props.label}</p>
      <CustomTableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>&nbsp;</TableCell>
              {columnOptions.map((item) => (
                <TableCell key={item.alias} width={width}>
                  {item.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowOptions.map((row) => (
              <TableRow key={row.alias}>
                <TableCell width={width}>{row.label}</TableCell>
                {columnOptions.map((column) => (
                  <TableCell width={width} key={column.alias}>
                    <RadioGroup
                      value={selectedOptions[row.alias]}
                      onChange={(event) => handleRadioChange(event, row.alias)}
                    >
                      <FormControlLabel value={column.alias} control={<Radio />} />
                    </RadioGroup>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CustomTableContainer>
    </div>
  );
}

export default React.memo(withFormsy(TabularSingleFormsy));
